import { MentionAtomExtension } from "remirror/extensions";

export const createMentionExtension = (options) => {
  const mentionOptions = {
    priority: 10_000,
    extraAttributes: {
      "data-mention-atom-id": { default: "" },
      "data-mention-atom-name": { default: "" },
      contenteditable: { default: "false" },
    },
    matchers: options
      .filter(({ name }) => name !== "emoji")
      .map(({ name, char }) => ({
        name,
        char,
        supportedCharacters: /[\w\d_ ]+/,
        suggestClassName: "mention-suggest",
        mentionClassName: "mention",
      })),
    mentionTag: "a",
    suggestTag: "a",
  };
  return new MentionAtomExtension(mentionOptions);
};
